import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import '../css/colaboradores.css';

function Colaboradores() {
  const [colaboradores, setColaboradores] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const docs = [];
    try {
      const querySnapshot = await getDocs(collection(db, "colaboradores"));
      querySnapshot.forEach((doc) => {
        docs.push({ ...doc.data(), id: doc.id });
      });
      setColaboradores(docs);
    } catch (error) {
      console.error("Error obteniendo colaboradores:", error);
    } finally {
      setIsFetching(false);
    }
  };

  if (isFetching) {
    return (
      <div className="loader-container">
        <div className="spinner-border" role="status"></div>
      </div>
    );
  }

  return (
    <div className="main">
      <div className="page">
        

        {/* --- GRID DE COLABORADORES CUADRADOS --- */}
        <div className="colaboradores-grid-squared">
          {colaboradores.map((each) => (
            <div className="card-colaborador-square" key={each.id}>
              <div className="foto-container-square">
                <img src={each.foto} alt={each.nombre || "Colaborador"} />
              </div>
              {/* Nombre opcional centrado */}
              {each.nombre && <p className="nombre-colaborador-square">{each.nombre}</p>}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Colaboradores;